<!--style type="text/css" scope>
  #idTabela tr:nth-child(1) {background-color: #49a9d9;}
  #idTabela tr:nth-child(2) {background-color: #79c0e3;}
  #idTabela tr:nth-child(3) {background-color: #a9d6ed;}
  #idTabela tr:nth-child(4) {background-color: #d9edf7;}
  #idTabela tr:nth-child(5) {background-color: #ecf6fb;}
</style-->

<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja"class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>Campanha Toscana</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="row" style="margin-bottom: 30px">
          <div class="col-xs-12">
            <img width="1170" height="281" :src="$imageUrl + '/Content/img/campanha/435/bannerinterno-20190830050044578_1140x281.jpg'" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div class="alert alert-info" role="alert">
              <i class="fa fa-trophy"></i>
              <span><b>{{ posicao }}</b></span>
            </div>
          </div>

          <div class="col-md-3">
            <div class="alert alert-info" role="alert">
              <i class="fa fa-lightbulb-o"></i>
              <span><b> Potência: {{ potencia }} kWp</b></span>
            </div>
          </div>

          <div class="col-md-6">
            <div class="alert alert-info" role="alert">
              <i class="fa fa-calendar"></i>
              <span><b> Atualizado em: {{ atualizacao }}</b></span>
            </div>
          </div>
        </div>

        <Loader v-if="loadingRank"/>

        <div class="row" v-if="!loadingRank">
          <div class="col-md-12">
            <div class="row">
              <div class="col-xs-12">
                <vue-good-table
                  :columns="columns"
                  :rows="registros"
                  :sort-options="{
                    enabled: false
                  }"
                  styleClass="vgt-table"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'razaoSocial'
                    && props.formattedRow[props.column.field] != 'CONFIDENCIAL'"><strong>{{props.formattedRow[props.column.field]}}</strong></span>
                    <span v-else>{{props.formattedRow[props.column.field]}}</span>
                  </template>
                  <div slot="emptystate">Sem dados para exibição</div>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import "vue-good-table/dist/vue-good-table.css";

import { VueGoodTable } from "vue-good-table";
import FormHelper from "./partials/FormHelper.vue";
import axios from "axios";

export default {
  name: "CampanhaToscana",
  components: {
    VueGoodTable,
    FormHelper
  },
  data() {
    return {
      columns: [
        { label: "Posição", field: "posicao" },
        { label: "Razao Social", field: "razaoSocial" },
        { label: "Potência (KWP)", field: "potencia" }
      ],
      registros: [],
      loadingRank: true,
      posicao: '',
      atualizacao: '',
      potencia:''
    };
  },
  mounted(){
    const self = this;

    $.ajax({
      url: this.$apiUrl + "Session.svc/getsessions",
      dataType: "json",
      type: "GET",
      xhrFields: { withCredentials: true },
      success: () => {
        self.getDados();
        self.minhaPosicao();
        self.minhaPotencia();
        self.ultimaAtualizacao();
      },
      error: () => {
        swal({
          title: "É necessário estar logado",
          icon: "warning"
        }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href)
      }
    });
  },
  methods: {
    formatCurrency: function(v) {
      //formada coluna de valores da tabela para moeda
      var formato = {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL"
      };
      return parseFloat(v).toLocaleString("pt-BR", formato);
    },
    getDados: function() {
      this.registros = [];

      //dados de exemplo para tabela
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4 && xhr.status == 200){
          let json = JSON.parse(xhr.responseText);

          json.forEach((element, index) => {
            let item = {};
            item.razaoSocial = element.razao;
            item.potencia = element.potencia;
            item.posicao = element.posicao;

            this.registros.push(item);
            //// // console.log(item);
          });

          this.loadingRank = false;
        }
      }
      xhr.open("GET", this.$apiUrl + "Cliente.svc/getmyrank");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.withCredentials = true;
      xhr.send();
    },
    minhaPosicao : function(){
      const self = this;
        axios({
          method: "POST",
          url: self.$apiUrl + "Cliente.svc/getmypos",
          withCredentials: true,
          contentType :"application/json",
          dataType : 'json'
        }).then(response => {
            self.posicao = response.data;
        });
    },
    minhaPotencia : function(){
      const self = this;
        axios({
          method: "POST",
          url: self.$apiUrl + "Cliente.svc/getmypotency",
          withCredentials: true,
          contentType :"application/json",
          dataType : 'json'
        }).then(response => {
            self.potencia = response.data;
        });
    },
    ultimaAtualizacao : function(){
      const self = this;
        axios({
          method: "POST",
          url: self.$apiUrl + "Cliente.svc/getatualizacao",
          withCredentials: true,
          contentType :"application/json",
          dataType : 'json'
        }).then(response => {
            self.atualizacao = response.data;
        });
    }
  }
};
</script>
